import { inject, Injectable } from '@angular/core';
import { JobDetailsStore } from 'src/app/recruiting/locums-margin-calculator/store/job-details/job-details.store';
import { MarginSetupStore } from 'src/app/recruiting/locums-margin-calculator/store/margin-setup/margin-setup.store';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { JobService } from 'src/app/recruiting/locums-margin-calculator/services/job.service';
import { JobInfo } from 'src/app/recruiting/locums-margin-calculator/models/job-info.model';
import { initialJobDetailsSlice } from 'src/app/recruiting/locums-margin-calculator/store/job-details/job-details.slice';
import { initialMarginSetupSlice } from 'src/app/recruiting/locums-margin-calculator/store/margin-setup/margin-setup.slice';
import { EventBusService } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from 'src/app/recruiting/locums-margin-calculator/store/enums/locums-margin-calculator-events.enum';

@Injectable({ providedIn: 'root' })
export class JobEffects {
    private readonly jobDetailsStore = inject(JobDetailsStore);
    private readonly marginSetupStore = inject(MarginSetupStore);
    private readonly jobService = inject(JobService);
    private readonly eventBus = inject(EventBusService);

    readonly getJobDetails = rxMethod<number>((query$) =>
        query$.pipe(
            switchMap((jobId: number) =>
                this.jobService.getJobInfo(jobId).pipe(
                    tapResponse({
                        next: (jobInfo: JobInfo) => {
                            this.updateStores(jobInfo);

                            this.eventBus.emit({
                                type: LocumsMarginCalculatorEvents.JOB_DETAILS_LOADED,
                                payload: {
                                    facilityId: jobInfo.facilityId,
                                    billRate: jobInfo.billRate,
                                    twentyFourHourCallBillRate: jobInfo.twentyFourHourCallBillRate,
                                    payPeriodTypeId: jobInfo.payPeriodTypeId
                                }
                            });
                        },
                        error: () => {
                            this.jobDetailsStore.updateJobDetailsFromData({ ...initialJobDetailsSlice });
                            this.marginSetupStore.updateMarginSetupFromData({ ...initialMarginSetupSlice });
                        }
                    })
                )
            )
        )
    );

    private updateStores(jobInfo: JobInfo) {
        this.jobDetailsStore.updateJobDetailsFromData({
            jobTitle: jobInfo.jobTitle,
            jobId: jobInfo.jobId,
            employmentType: jobInfo.employmentType,
            facilityId: jobInfo.facilityId,
            facilityName: jobInfo.facilityName,
            facilityLocation: jobInfo.facilityLocation,
            profession: jobInfo.profession,
            professionId: jobInfo.professionId,
            specialtyId: jobInfo.specialtyId,
            specialty: jobInfo.specialty,
            unitId: jobInfo.unitId,
            unitFormId: jobInfo.unitFormId,
            unitDescription: jobInfo.unitDescription,
            accountManager: jobInfo.accountManager,
            accountCoordinator: jobInfo.accountCoordinator,
            billRate: jobInfo.billRate,
            payPeriodTypesId: jobInfo.payPeriodTypeId,
            twentyFourHourCallBillRate: jobInfo.twentyFourHourCallBillRate
        });
    }
}
